import { useState } from 'react';
import type { ScoreEntry } from '@photo-merge/shared';
import styles from './ScoreStrip.module.css';

interface ScoreStripProps {
  scores: ScoreEntry[] | null;
  onOpen: () => void;
  shareUrl: string;
}

export function ScoreStrip({ scores, onOpen, shareUrl }: ScoreStripProps) {
  const [copied, setCopied] = useState(false);
  const leader = scores?.[0];

  async function share() {
    if (navigator.share) {
      try {
        await navigator.share({ title: 'MergeBalls', url: shareUrl });
        return;
      } catch {
        /* dismissed — fall through to copying */
      }
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className={styles.strip}>
      <button className={styles.leader} onClick={onOpen}>
        <span className={styles.crown} aria-hidden="true">
          👑
        </span>
        {leader ? (
          <>
            <span className={styles.who}>{leader.name}</span>
            <span className={styles.points}>{leader.score.toLocaleString()}</span>
          </>
        ) : (
          <span className={styles.who}>
            {scores === null ? 'Loading scores…' : 'No scores yet — be the first'}
          </span>
        )}
        <span className={styles.chev} aria-hidden="true">
          ▲
        </span>
      </button>
      <button
        className={[styles.share, copied ? styles.copied : ''].filter(Boolean).join(' ')}
        onClick={() => void share()}
        aria-label="Share this game"
        title="Share this game"
      >
        {copied ? '✓' : '🔗'}
      </button>
    </div>
  );
}
